import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import translationEN from "../locales/en/translation.json";
import translationJA from "../locales/ja/translation.json";

// サポートする言語のリスト
// 言語を追加する場合は、対応する翻訳ファイルを src/locales/<lng>/translation.json に用意し、
// ここと下記 resources に追記する。
export const supportedLngs = {
  ja: "日本語",
  en: "English",
};

i18n
  .use(LanguageDetector) // ブラウザの言語設定を検知する
  .use(initReactI18next) // i18next インスタンスを初期化
  .init({
    // 翻訳リソースをバンドルに直接内包することで、非同期HTTPロードによる
    // ちらつき（FOUC: Flash of Untranslated Content）を防止する
    resources: {
      ja: { translation: translationJA },
      en: { translation: translationEN },
    },
    fallbackLng: "en", // フォールバック言語。ユーザー環境の言語が未サポートの場合はこの言語（英語）が使用される
    returnEmptyString: false, // 空文字での定義を許可に
    returnNull: false, // null返却を無効化（t()の戻り値型を string 固定にする）
    supportedLngs: Object.keys(supportedLngs), // ["ja", "en"] のみサポート。未サポート言語は fallbackLng（en）に自動フォールバック
    debug: false, // true にすると開発コンソールに i18next が正しく初期化されたことを示す出力が表示される

    // 言語検出の優先順位: ①localStorage（ユーザーの手動選択） → ②ブラウザの言語設定
    // いずれにも一致しない/存在しない場合は fallbackLng（en）が適用される
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"], // UIから言語を変更した際の選択結果もここに保存される
      lookupLocalStorage: "i18nextLng",
    },

    // React が自動エスケープするため escapeValue は false に設定
    // （true にすると補間変数内の "/" 等が &#x2F; 等にエスケープされ画面に文字化けして表示される）
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
